module.exports = __webpack_public_path__ + "img/first-job-1-min.9f05585b.png";